import React, { useMemo, useState, createContext, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useParams} from "react-router-dom";
import Contexto from "../comun/Contexto";
import MapaIntensidades from "./MapaIntensidades";
import LeyendaIntensidades from "./LeyendaIntensidades";


export default function MapaIntensidadesWrapper() {        
    const [cargando, setCargando] = useState(true);
    const [resumen, setResumen] = useState();
    
    const valueRef = useRef({});
    const resumenRef = useRef(null);    

    let params = useParams();
    console.log("params")
    console.log(params)        
    
    useEffect(() => {        
        fetch('/config.json').then(response => {            
            if (!response.ok) {
                throw new Error("Error cargando la configuracion " + response.status);
            }
            return response.json();
        }).then(json => {  
            valueRef.current = json;
            
            fetch(json.urlBaseRest+"resumen_sismo/"+ params.idSismo).then(response2 => {
                if (!response2.ok) {
                    throw new Error("Error cargando resumen del sismo " + response2.status);
                }
        
                return response2.json();
            }).then(json2 => {
                resumenRef.current = json2;
                setCargando(false)
            })
        }).catch(function (e) {            
            console.log("paramsE")
            console.log(params)       
            throw new Error("Error cargando la configuracion " + e);
            
        })
    }, []);    
    

    if (cargando) {
        return <div>Cargando...</div>    
    }
    else return (       
        <Contexto.Provider value={valueRef.current}>
            <div style={{width:"100vw", height: "100vh", display:"flex", flexDirection:"column"}}>                
                <MapaIntensidades idSismo={params.idSismo} centro={[params.centroLat, params.centroLon]}
                zoom={params.zoom}
                resumenSismo={resumenRef.current}/>
                <LeyendaIntensidades fontSize={valueRef.current.mapaIntensidadesTamanoFuente}
                mostrarTooltips={true}/>                                
            </div>
        </Contexto.Provider>
    )
}